import { nextDelay } from './backoff'

/** Spec 041: the live-session list is read every 10 s while it matters. */
export const LIVE_LIST_POLL_MS = 10_000

/**
 * The next delay for the live-session list poll, or `null` when nothing should
 * be scheduled: the tab is hidden, or neither the Live pane is open nor does the
 * last answer hold an active session. After failures the Quant back-off applies
 * (2, 4, 8, then 15 s); otherwise 10 s.
 */
export function livePollDelay(input: {
  visible: boolean
  paneOpen: boolean
  hasActive: boolean
  failures: number
}): number | null {
  if (!input.visible) return null
  if (!input.paneOpen && !input.hasActive) return null
  if (input.failures > 0) return nextDelay(input.failures)
  return LIVE_LIST_POLL_MS
}
